import React from 'react'
import SubHeader from '../../layout/components/SubHeader'
import {toAbsoluteUrl} from '../../helpers/AssetHelpers'
import PasswordUpdateComponent from "./PasswordUpdateComponent";

function PasswordUpdate() {
    return (
        <>
            <SubHeader title="Change Password" description={"Update your password."}/>

                        <PasswordUpdateComponent/>

        </>
    )
}

export default PasswordUpdate